import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import '../styles/MainView.css'
import logoutIcon from '../images/logout.png'
import key from '../images/key.png'
import Login from './Login'
import Sidebar from './SidebarNationalAdmin'
import ContainerWidget from '../widgets/ContainerWidget'
import OtherProjectListNational from '../other_projects/OtherProjectListNational'
import SitesListView from '../sites/SitesListView'
import SiteCreation from '../sites/SiteCreation'
import APISiteRequest from '../api/APISiteRequest'
import AlertMessage from '../widgets/AlertMessage'
import Dashboard from '../dashboard/Dashboard'
import ModuleCollection from './ModuleCollection'
import CropsCollection from './CropsCollection'
import ReportsNational from '../reports/ReportsNational'

class NationalAdmin extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			site: null,
			showConfirmMessage: false
		}
		sessionStorage.setItem("sidebar-item", "calendar")
		this.onContentHeaderClick = this.onContentHeaderClick.bind(this)
		this.handleSidebarEvent = this.handleSidebarEvent.bind(this)
		this.handleContentEvent = this.handleContentEvent.bind(this)
		this.setSiteView = this.setSiteView.bind(this)
		this.setModuleView = this.setModuleView.bind(this)
		this.setSite = this.setSite.bind(this)
		this.deleteSite = this.deleteSite.bind(this)
		this.getAllSitesByProvinceId = this.getAllSitesByProvinceId.bind(this)
		this.setOtherProjectView = this.setOtherProjectView.bind(this)
	}

	onContentHeaderClick(signal, value) {
		const sidebarItem = (Array.isArray(signal))? signal[0]: signal
		switch(sidebarItem) {
			case "sites":
				let sv
				if(value === "update") {
					sv = value
				}
				else if(value === "delete") {
					this.setState({
						showConfirmMessage: true,
						aMessage: "Are you sure you want to delete this site?",
						siteSignal: signal
					})
					break
				}
				else {
					sv = "list-view"
				}
				this.setSiteView(sv, signal[1])
				break
			case "modules":
				this.setModuleView(value)
				break
			case "other-projects":
				this.setOtherProjectView(value)
				break
			case "crops":
				this.setCropsView(value)
				break
			case "reports":
				this.setReportView()
			default:
		}
	}

	handleSidebarEvent(value) {
		sessionStorage.setItem("sidebar-item", value)
		switch(value) {
			case "dashboard":
				this.setState({content: <Dashboard />})
				break
			case "sites":
				this.setSiteView("list-view")
				break
			case "modules":
				this.setModuleView()
				break
			case "other-projects":
				this.setOtherProjectView()
				break
			case "crops":
				this.setCropsView()
				break
			case "reports":
				this.setReportView()
		}
	}

	setSite(id) {
		this.setState({siteId: id})
		const si = sessionStorage.getItem("sidebar-item")
		switch(si) {
			case "calendar":
				this.setCalendarView()
				break
			case "organizations":
				this.setOrganizationView("list-view")
				break
			case "farmers":
				this.setFarmerView("list-view")
				break
			case "clusters":
				this.setClusterView("list-view")
				break
			case "reports":
				this.setReportView()
		}
	}

	setSiteView(view, siteId, siteName) {
		switch(view) {
			case "list-view":
				this.getAllSitesByProvinceId()
				var content = <ContainerWidget title="SITES"
					content={<SitesListView createSite={this.setSiteView}
					viewDetails={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					signal={"sites"} key="sc" />
				break
			case "create-site":
				content = <ContainerWidget title="SITE CREATION FORM"
					content={<SiteCreation onSignal={this.onContentHeaderClick}
						viewDetails={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					signal={"sites"} key="scc" />

				break
			case "view-details":
				content = <ContainerWidget title="SITE DETAILS"
					content={<SiteCreation id={siteId} view={"view-details"} />}
					onClick={this.onContentHeaderClick}
					showUpdate={true}
					showClose={true}
					showDelete={true}
					signal={["sites", siteId, siteName]} key="sd" />
				break
			case "update":
				content = <ContainerWidget title="UPDATE SITE DETAILS"
					content={<SiteCreation id={siteId} view={"update"}
						onSignal={this.onContentHeaderClick} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					showDelete={true}
					signal={["sites", siteId, this.state.siteName]} key="usd" />
				break
			default:
				this.getAllSitesByProvinceId()
				content = <ContainerWidget title="SITES"
					content={<SitesListView createSite={this.setSiteView}
					viewDetails={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					signal={"sites"} key="sc" />
		}
		this.setState({content: content, siteName: siteName})
	}

	deleteSite() {
		const sites = APISiteRequest.deleteSite(this.state.accessToken, this.state.siteSignal[1])
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.setSiteView("list-view")
			this.setState({
				showConfirmMessage: false,
				showInfoMessage: true,
				aMessage: "Site " + this.state.siteSignal[2] + " deleted."
			})
		})
	}

	setModuleView(view) {
		switch(view) {
			case "update":
				var content = <ContainerWidget title="UPDATE MODULES"
					content={<ModuleCollection view={"update"}
						onSignal={this.onContentHeaderClick} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					signal={"modules"} key="um" />
				break
			default:
				content = <ContainerWidget title="MODULES"
					content={<ModuleCollection view={"view-details"} disabled={true} />}
					onClick={this.onContentHeaderClick}
					showUpdate={true}
					signal={"modules"} key="m" />
		}
		this.setState({content: content})
	}

	setCropsView(view) {
		switch(view) {
			case "update":
				var content = <ContainerWidget title="CROPS"
					onClick={this.onContentHeaderClick}
					content={<CropsCollection disabled={false} view="add" />}
					showClose={true}
					signal={"crops"} key="aop" />
				break
			default:
				content = <ContainerWidget title="CROPS"
					onClick={this.onContentHeaderClick}
					content={<CropsCollection disabled={true} />}
					showUpdate={true}
					signal={"crops"} key="op" />
		}
		this.setState({content: content})
	}

	setOtherProjectView(view) {
		switch(view) {
			case "update":
				var content = <ContainerWidget title="OTHER PROJECTS"
					onClick={this.onContentHeaderClick}
					content={<OtherProjectListNational disabled={false} view="add" />}
					showClose={true}
					signal={"other-projects"} key="aop" />
				break
			default:
				content = <ContainerWidget title="OTHER PROJECTS"
					onClick={this.onContentHeaderClick}
					content={<OtherProjectListNational disabled={true} />}
					showUpdate={true}
					signal={"other-projects"} key="op" />
		}
		this.setState({content: content})
	}

	setReportView() {
		this.setState({content: <ContainerWidget title="REPORTS"
			content={<ReportsNational/>} key="reports" />})
	}

	handleContentEvent(e) {
	}

	getAllSitesByProvinceId() {
		const sites = APISiteRequest.getAllSitesByProvinceId(this.state.accessToken, this.state.user.province_id)
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.site_id, name: v.name})
			}
			this.setState({siteData: c})
		})
	}

	componentWillMount() {
		this.getAllSitesByProvinceId()
		this.setSiteView("list-view")
		// this.setState({content: <Dashboard />})
	}

	render() {
		return(<div id="main-view">
			<Header user={this.state.user} setSite={this.setSite} siteData={this.state.siteData} />
			<Sidebar type={"account-type"} onMenuItemClick={this.handleSidebarEvent} />
			<ContentPane content={this.state.content} onChangeBody={this.handleContentEvent} />
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
				}} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.setState({showConfirmMessage: false})
					}
					else {
						if(this.state.clusterSignal != null) {
							this.archiveCluster()
						}
						else if(this.state.siteSignal != null) {
							this.deleteSite()
						}
					}
				}} />}
		</div>)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
	}

	render() {
		const extName = (this.props.user.extension_name == null)? "": this.props.user.extension_name
		const mi = (this.props.user.middle_name == null)? "": this.props.user.middle_name
		const name = this.props.user.first_name + " " + mi + " " + this.props.user.last_name + " " + extName
		const view = <div id="header">
			<div id="header-site">
				<div id="title">LINKSFARMM MELA</div>
			</div>
			<div id="account-name">
				<div id="role">{this.props.user.role}</div>
				<ul><li class="drop">
					<button>{name.toUpperCase()}</button>
					<div class="dropdown">
						<div class="dropout">
							<ul>
								<li id="change-pw" onClick={() => {
									console.log("CHANGE PASSWORD")
								}}><span>
									<img src={key} />
									<label>CHANGE PASSWORD</label>
								</span></li>
								<li id="logout" onClick={() => {
									ReactDOM.render(<Login />, document.getElementById("app"))
								}}><span>
									<img src={logoutIcon} />
									<label>LOGOUT</label>
								</span></li>
							</ul>
						</div>
					</div>
				</li></ul>
			</div>
		</div>
		return(view)
	}
}

function ContentPane(props) {
	return(<div id="content-pane">
		{props.content}
	</div>)
}

export default NationalAdmin
